import { render, staticRenderFns } from "./RecentPayments.vue?vue&type=template&id=55ac64ec&"
import script from "./RecentPayments.vue?vue&type=script&lang=js&"
export * from "./RecentPayments.vue?vue&type=script&lang=js&"
import style0 from "./RecentPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports